import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { HousingTypeEnum, HeatingTypeEnum, TarificationIdEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import { TarificationFormat } from "../../../../../Scripts/inpulse/FormatUtils";
import HorizontalFormGroup from "../phases/horizontal-form-group.vue";
import { AddressFormat } from "../../../../../Scripts/inpulse/AddressFormat";

@Component({
    components: { HorizontalFormGroup }
})

export default class MoveOutCustomerSelectionDisplay extends Vue {
    get lastInvoiceAddressString(): string {
        return AddressFormat.toSingleString(this.contract.MoveOutProcess.FinalInvoicingAddress.Address, { coName: true });
    }

    @Prop()
    public contract: any;

    HousingTypeEnum: typeof HousingTypeEnum = HousingTypeEnum;
    HeatingTypeEnum: typeof HeatingTypeEnum = HeatingTypeEnum;
    TarificationIdEnum: typeof TarificationIdEnum = TarificationIdEnum;
    TarificationFormat: typeof TarificationFormat = TarificationFormat;

    constructor() {
        super();
    }

    join(separator: string, strs: string[]) {
        let arr = [];
        strs.forEach(s => {
            if (s != null && s.length != 0)
                arr.push(s);
        });
        return arr.join(separator);
    }

    formatPostal(postalCode: string, postOffice: string) {
        let str = this.join(", ", [postalCode, postOffice]);
        return str;
    }
}